import {
    windowWidth,
    masterModel,
    mobileMatch,
    smoothScrollToTarget
} from "../common";

const $w = $(window);
const $DOC = $(document);

export default class Seminar {
    constructor() {
        this.el = document.querySelector('#seminar_page');
        this.$el = $(this.el);

        if (this.el) {
            $(".grouped_elements").fancybox({
                thumbs: {
                    autoStart: true
                }
            });
            Seminar._scrollMsg();
            Seminar._toggleGroupByHash();
        }

        masterModel($('.content.enabled').data('number'));

        if (windowWidth > 769) {
            $('.notActive_seminars span.more').on('hover', function () {
                $('.not_active_seminar_popUp').toggleClass('hide');
            });
        } else {
            $('.notActive_seminars span.more').on('click', function () {
                $('.not_active_seminar_popUp').toggleClass('hide');
            });
        }

        // $('.watchVideo').attr('href', $("#youTubeVideo iframe").attr("src"));

        $DOC
            .on('click', '.showGoogleMap', this._googleMapController)
            .on('click touchend', '.showForm.mob', Seminar._mobileForm)
            .on('click touchend', '.form_head div.mob', Seminar.anotherMobileForm)
            .on('click', '.close_form, .thxMessage div.mob span', Seminar.anotherMobileForm)
            .on('click', '.tabs .wrapper > .date_tabs .date_tabs_wrap > .tab', this._tabController)
            .on('click', '.hidden_tabs', this._onHiddenTabs)
            .on('click touchend', '.form_head div.mob', Seminar._anotherMobileFormEmpty)
            .on('click touchend', '.showForm_empty.mob', Seminar._mobileFormEmpty)
            .on('click', '.sale_min a, .show_more_discount', this._showDiscount)
            .on('click', '#section_3 h3.comment_tab', this._switchCommentTab)
            .on('click', '.tabs .wrapper > .date_tabs .date_tabs_wrap > .hidden_tabs >.tab', this._secondHiddenTabs)
            .on('click', '.watchVideo', Seminar._showYouTubePopup)
            .on('click', '.youTubeVideo__close', Seminar._hideYouTubePopup)
            .on('click', '.form--buttons-black_friday', Seminar._clickBlackFriday)
            .on('click', '.js-go-section-3', smoothScrollToTarget);


        $w
            .on('scroll', Seminar._fixDiv)
            .on('click',  Seminar._windowClick)
            .on('scroll', Seminar._scrollMsg);


        if (window.location.search
            && window.location.search.indexOf('order')
            && mobileMatch.matches) Seminar._mobileForm();
    }

    //fixed tabs on seminar_page mobile
    static _fixDiv() {
        let $cache = $('.tabs .wrapper');

        if ($('.tabs').length && $w.scrollTop() > $('.tabs').offset().top)
            $cache.addClass('mob_fixed');
        else
            $cache.removeClass('mob_fixed');
    }

    static _showYouTubePopup(e) {
        e.preventDefault();
        e.stopPropagation();
        $('#youTubeVideo').show();
    }

    static _hideYouTubePopup() {
        let iframe = $('#youTubeVideo').find('iframe'),
            src = iframe.attr('src');
        // iframe.attr('src', '');
        iframe.attr('src', src);
        $('#youTubeVideo').hide();
    }

    _googleMapController() {
        let tabing = $(this).closest('.content').attr('id');
        if ($('#' + tabing + ' .showGoogleMap').hasClass('hideGoogleMap')) {

            $(this).text($(this).data('show'));
        } else {
            $(this).text($(this).data('hide'));
        }
        $('#' + tabing + ' .showGoogleMap').toggleClass('hideGoogleMap');
        $('#' + tabing + ' .googleMap').toggleClass('opac');
    }

    static _mobileForm() {
        // Если что, я такое не писал
        $('.content.enabled .right_form').show().css({'z-index': '20', 'margin': 0, 'transform': 'none'});
        $('jdiv').css('display', "none");
        $('#seminar_page, #seminar_page #section_2 .wrapper').css({'padding': 0, 'max-width': '100vw'});
        $('#section_1, #section_3, #section_4, header, footer, .geo_section, .key_info_block').css({'display': 'none'});
        $('#section_2 .tabs, #section_2 .content.disabled, #section_2 .content .background_3, #section_2 .content .background_2 .left_side, #section_2 > .center_wrapper').css('display', 'none');
    }

    static anotherMobileForm() {
        // и это я тоже не писал и вообще я только переводил на страницы скрипты
        $('.right_form').hide().css({'z-index': '', 'margin': '', 'transform': ''});
        $('jdiv').css('display', "");
        $('#seminar_page, #seminar_page #section_2 .wrapper').css({'padding': '', 'max-width': ''});
        $('#section_1, #section_3, #section_4, footer, .geo_section, .key_info_block').css('display', 'block');
        $('header').css('display', 'flex');
        $('#section_2 .tabs, #section_2 .content.disabled, #section_2 .content .background_3, #section_2 .content .background_2 .left_side, #section_2 > .center_wrapper').css('display', 'block');
    }

    _tabController() {
        if (!$(this).hasClass("more_tabs")) {
            let contentController = $('.section_2 .content');
            let personController = $('.section_2 .person_tabs');
            let personControllerMob = $('.mobile_persona_tabs .tabs_p');
            let textMore = $('.tab.more_tabs').text();

            if ($('.tab.more_tabs').text() !== textMore) {
                $('.tab.more_tabs').text(textMore);
            }
            let curBlock = $(this);
            $('.tabs .wrapper > .date_tabs .date_tabs_wrap > .tab').removeClass("active");
            // $('.tabs .wrapper > .date_tabs > .tab').removeClass("active");
            $('.hidden_tabs .tab').removeClass('active');
            $(curBlock).addClass("active");

            if ($('.tabs .tab').length === 1) {
                $('.tabs .tab.active').removeClass("noteOne").css("color", "#000");
            } else {
                $('.tabs .tab.active').addClass("noteOne");
            }

            for (let j = 0; j < contentController.length; j++) {
                let contentAttr = $(contentController[j]);
                let tabAttr = $(personController[j]);
                let tabAttrMob = $(personControllerMob[j]);
                if (curBlock.attr("data-value") === $(contentAttr).attr("data-value")) {
                    $(contentAttr).addClass("enabled");
                    $(tabAttr).addClass("enabled");
                    $(tabAttrMob).addClass("enabled");
                    $(contentAttr).removeClass("disabled");
                    $(tabAttr).removeClass("disabled");
                    $(tabAttrMob).removeClass("disabled");
                    masterModel($(contentAttr).data("number"));
                } else {
                    $(contentAttr).addClass("disabled");
                    $(tabAttr).addClass("disabled");
                    $(tabAttrMob).addClass("disabled");
                    $(contentAttr).removeClass("enabled");
                    $(tabAttr).removeClass("enabled");
                    $(tabAttrMob).removeClass("enabled");
                }
            }
        }
        $('.hidden_tabs').css('left', $('.date_tabs_wrap').width() - 200);
    }

    _onHiddenTabs() {
        if ($(this).hasClass("more_tabs")) {
            let contentController = $('.section_2 .content');
            let personController = $('.section_2 .person_tabs');
            let tabsController = $('.tabs .wrapper > .date_tabs .date_tabs_wrap > .tab');
            tabsController.removeClass('active');
            $('.tab').removeClass('active');
            $('.tab.more_tabs').addClass('active');
            $(this).addClass('active').attr("disabled", 'true');
            $('.tab.more_tabs').text($(this).text());
            for (let i = 0; i < contentController.length; i++) {
                let contentAttr = $(contentController[i]);
                let tabAttr = $(personController[i]);
                if ($(this).attr("data-value") === $(contentAttr).attr("data-value")) {
                    $(contentAttr).addClass("enabled");
                    $(tabAttr).addClass("enabled");
                    $(contentAttr).removeClass("disabled");
                    $(tabAttr).removeClass("disabled");
                    masterModel($(contentAttr).data("number"));
                } else {
                    $(contentAttr).addClass("disabled");
                    $(tabAttr).addClass("disabled");
                    $(contentAttr).removeClass("enabled");
                    $(tabAttr).removeClass("enabled");
                }
            }
        }

    }

    _secondHiddenTabs() {
        let curBlock = $(this);
        let sibBlock = $(this).siblings('.tabs .wrapper > .date_tabs .date_tabs_wrap > .hidden_tabs >.tab');
        let hiddenTabs = $('.tabs .wrapper > .date_tabs .date_tabs_wrap > .hidden_tabs >.tab');
        let tabsController = $('.tabs .wrapper > .date_tabs .date_tabs_wrap > .tab');
        let contentController = $('.section_2 .content');
        sibBlock.removeClass("active");
        $(tabsController).removeClass("active");
        $(hiddenTabs).not(sibBlock).addClass("active");

        for (let j = 0; j < contentController.length; j++) {
            let contentAttr = $(contentController[j]);
            if (curBlock.attr("data-value") === $(contentAttr).attr("data-value")) {
                $(contentAttr).addClass("enabled");
                $(contentAttr).removeClass("disabled");
            } else {
                $(contentAttr).addClass("disabled");
                $(contentAttr).removeClass("enabled");
            }
        }
    }

    static _toggleGroupByHash() {
        let hash = window.location.hash;
        let dates = document.querySelector('.date_tabs_wrap').querySelectorAll('.tab');
        let tabs = document.querySelector('#section_2').querySelectorAll('.content');

        if (hash.length > 0) {
            hash = hash.slice(1);

            dates.forEach((e) => {
                e.classList.remove('active');
                if (e.getAttribute('data-value') === hash) e.classList.add('active');
            });

            tabs.forEach((e) => {
                e.classList.remove('enabled');
                e.classList.add('disabled');
                if (e.getAttribute('data-value') === hash) {
                    e.classList.add('enabled');
                    e.classList.remove('disabled');
                }
            });
        }
    }

    static _windowClick(event) {
        if (!mobileMatch.matches && !$(event.target).is('.tab.more_tabs'))
            $('.hidden_tabs').slideUp(100);
    }

    static _mobileFormEmpty() {
        $('.right_form').show().css({'z-index': '20', 'margin': 0, 'transform': 'none', 'display': 'block'});
        $('jdiv').css('display', "none");
        $('#seminar_page, #seminar_page #section_2 .wrapper').css({'padding': 0, 'max-width': '100vw'});
        $('#section_1, #section_3, #section_4, header, footer, .geo_section').css({'display':'none'});
        $('#section_2 .tabs, #section_2 .content.disabled, #section_2 .content .background_3, #section_2 .content .background_2 .left_side, #section_2 > .center_wrapper').css('display', 'none');
    }

    static _anotherMobileFormEmpty() {
        $('.right_form').hide().css({'z-index': '', 'margin': '', 'transform': ''});
        $('jdiv').css('display', "");
        $('#seminar_page, #seminar_page #section_2 .wrapper').css({'padding': '', 'max-width': ''});
        $('#section_1, #section_3, #section_4, footer, .geo_section').css('display', 'block');
        $('header').css('display', 'flex');
        $('#section_2 .tabs, #section_2 .content.disabled, #section_2 .content .background_3, #section_2 .content .background_2 .left_side, #section_2 > .center_wrapper').css('display', 'block');
    }

    _showDiscount(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.sale_more').toggleClass('hide');
    }

    _switchCommentTab() {
        if (!$(this).hasClass('active')) {
            $('#section_3 h3.comment_tab').removeClass('active');
            $(this).addClass('active');
            $('#section_3 .more_about_seminar').toggleClass('hide');
            $('#section_3 .comments_block').toggleClass('hide');
        }
    }

    static _scrollMsg() {
        let msg = $('.right_form'),
            paddingBottom = 40,
            headerHeight = document.querySelector('header').clientHeight;
        if ($w.width() > 1024 && $(msg).hasClass('for_empty') !== true) {
            if ($w.scrollTop() >= headerHeight + paddingBottom) {
                msg.addClass('fixed');
            } else {
                msg.removeClass('fixed');
            }
        }
    }

    static _clickBlackFriday(e) {
        main_form.submit($(e.currentTarget).closest('form')[0], true);
    }
}
